// extracted by mini-css-extract-plugin
module.exports = {"searchFieldLabel":"_1L6tH83JVdNgdwdGbbbEYY","searchFieldInput":"_1WSMR54-dlfxzBYOxdMZEu"};